import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'


const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL),
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      redirect: '/list',
    },
    {
      path: '/list',
      name: 'list',
      component: () => import('@/views/list.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home.vue')
    },
    {
      path: '/order',
      name: 'order',
      component: () => import('@/views/order.vue')
    },
    {
      path: '/integral',
      name: 'integral',
      component: () => import('@/views/integral.vue')
    },
    {
      path: '/coupon-my',
      name: 'couponMy',
      meta: {
        keepAlive: true
      },
      component: () => import('@/views/coupon-my.vue')
    },
    {
      path: '/coupon-receive',
      name: 'couponReceive',
      meta: {
        keepAlive: true
      },
      component: () => import('@/views/coupon-receive.vue')
    },
    {
      path: '/coupon-history',
      name: 'coupon-history',
      component: () => import('@/views/coupon-history.vue')
    },
    {
      path: '/coupon-detail',
      name: 'coupon-detail',
      component: () => import('@/views/coupon-detail.vue')
    },
    {
      path: '/:catchAll(.*)',
      component: () => import('@/views/404.vue')
    }
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (About.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import('../views/AboutView.vue')
    // }
  ]
})

export default router
